import { defineMessages } from "react-intl"
import TextFormatIcon from "@material-ui/icons/TextFormat"
import RoomIcon from "@material-ui/icons/Room"
import PhoneIcon from "@material-ui/icons/Phone"
import LanguageIcon from "@material-ui/icons/Language"
import MailIcon from "@material-ui/icons/Mail"
import DoneIcon from "@material-ui/icons/Done"
import DoneAllIcon from "@material-ui/icons/DoneAll"
import ChatIcon from "@material-ui/icons/Chat"
import SelectAllIcon from "@material-ui/icons/SelectAll"
import TuneIcon from "@material-ui/icons/Tune"
import Filter9PlusIcon from "@material-ui/icons/Filter9Plus"
import CalendarTodayIcon from "@material-ui/icons/CalendarToday"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import AttachMoneyIcon from "@material-ui/icons/AttachMoney"
import RemoveIcon from "@material-ui/icons/Remove"
import { words } from "../../../i18n/lstrings"

const messages = defineMessages({
  shortText: {
    id: "form.element.shortText",
    defaultMessage: "Short Text",
    description: "Form Element label : Short Text"
  },
  placeholder: {
    id: "word.placeholder",
    defaultMessage: "Placeholder",
    description: "Placeholder"
  },
  shortTextDefaultText: {
    id: "form.element.shortText.defaultText",
    defaultMessage: "Default Text",
    description: "Form Element label : Short Text - Default Text"
  },
  shortTextMinLength: {
    id: "form.element.shortText.minLength",
    defaultMessage: "Minimal Length",
    description: "Form Element label : Short Text - Minimal Length"
  },
  shortTextMaxLength: {
    id: "form.element.shortText.maxLength",
    defaultMessage: "Maximal Length",
    description: "Form Element label : Short Text - Maximal Length"
  },
  address: {
    id: "form.element.address",
    defaultMessage: "Address",
    description: "Form Element label : Address"
  },
  addressCityRequired: {
    id: "form.element.address.cityRequired",
    defaultMessage: "City Required",
    description: "Form Element label : Address - City Required"
  },
  addressPostalCodeRequired: {
    id: "form.element.address.postalCodeRequired",
    defaultMessage: "Postal Code Required",
    description: "Form Element label : Address - Postal Code Required"
  },
  addressCountryRequired: {
    id: "form.element.address.countryRequired",
    defaultMessage: "Country Required",
    description: "Form Element label : Address - Country Required"
  },
  phone: {
    id: "form.element.phone",
    defaultMessage: "Phone",
    description: "Form Element label : Phone"
  },
  country: {
    id: "form.element.country",
    defaultMessage: "Country",
    description: "Form Element label : Country"
  },
  mail: {
    id: "form.element.mail",
    defaultMessage: "Mail",
    description: "Form Element label : Mail"
  },
  dateSelector: {
    id: "form.element.dateSelector",
    defaultMessage: "Date Selector",
    description: "Form Element label : Date Selector"
  },
  dateSelectorMinDate: {
    id: "form.element.dateSelector.minDate",
    defaultMessage: "Minimal Date",
    description: "Form Element label : Date Selector - Minimal Date"
  },
  dateSelectorMaxDate: {
    id: "form.element.dateSelector.maxDate",
    defaultMessage: "Maximal Date",
    description: "Form Element label : Date Selector - Maximal Date"
  },
  scrollingList: {
    id: "form.element.scrollingList",
    defaultMessage: "Scrolling List",
    description: "Form Element label : Scrolling List"
  },
  scrollingListTagsList: {
    id: "form.element.scrollingList.tagsList",
    defaultMessage: "Tags List",
    description: "Form Element label : Scrolling List - Tags List"
  },
  monoSelection: {
    id: "form.element.monoSelection",
    defaultMessage: "Unique Selection",
    description: "Form Element label : Unique Selection"
  },
  multiSelection: {
    id: "form.element.multiSelection",
    defaultMessage: "Multi Selection",
    description: "Form Element label : Multi Selection"
  },
  currency: {
    id: "form.element.currency",
    defaultMessage: "Currency",
    description: "Form Element label : Currency"
  },
  scale: {
    id: "form.element.scale",
    defaultMessage: "Scale",
    description: "Form Element label : Scale"
  },
  scaleStartsAtOne: {
    id: "form.element.scale.startsAtOne",
    defaultMessage: "Starts at One",
    description: "Form Element label : Scale - Starts at One"
  },
  scaleMaxScale: {
    id: "form.element.scale.maxScale",
    defaultMessage: "Max Scale",
    description: "Form Element label : Scale - Max Scale"
  },
  scaleShowLabels: {
    id: "form.element.scale.showLabels",
    defaultMessage: "Show Labels",
    description: "Form Element label : Scale - Show Labels"
  },
  scaleLeftText: {
    id: "form.element.scale.leftText",
    defaultMessage: "Left Text",
    description: "Form Element label : Scale - Left Text"
  },
  scaleMiddleText: {
    id: "form.element.scale.middleText",
    defaultMessage: "Middle Text",
    description: "Form Element label : Scale - Middle Text"
  },
  scaleRightText: {
    id: "form.element.scale.rightText",
    defaultMessage: "Right Text",
    description: "Form Element label : Scale - Right Text"
  },
  number: {
    id: "form.element.number",
    defaultMessage: "Number",
    description: "Form Element label : Number"
  },
  numberPositiveOnly: {
    id: "form.element.number.positiveOnly",
    defaultMessage: "Positive Only",
    description: "Form Element label : Number - Positive Only"
  },
  numberMinValue: {
    id: "form.element.number.minValue",
    defaultMessage: "Minimal Value",
    description: "Form Element label : Number - Minimal Value"
  },
  numberMaxValue: {
    id: "form.element.number.maxValue",
    defaultMessage: "Maximal Value",
    description: "Form Element label : Number - Maximal Value"
  },
  percent: {
    id: "form.element.percent",
    defaultMessage: "Percent",
    description: "Form Element label : Percent"
  },
  separator: {
    id: "form.element.separator",
    defaultMessage: "Separator",
    description: "Form Element label : Separator"
  },
  freeText: {
    id: "form.element.freeText",
    defaultMessage: "Free Text",
    description: "Form Element label : Free Text"
  },
  matrixSelection: {
    id: "form.element.matrixSelection",
    defaultMessage: "Matrix Selection",
    description: "Form Element label : Matrix Selection"
  },
  matrixSelectionMonoSelection: {
    id: "form.element.matrixSelection.monoSelection",
    defaultMessage: "selection unique",
    description: "Form Element label : Matrix Selection - selection unique"
  },
  matrixSelectionTypeSelection: {
    id: "form.element.matrixSelection.typeSelection",
    defaultMessage: "Type Selection",
    description: "Form Element label : Matrix Selection - Type Selection"
  },
  matrixSelectionColumnSelection: {
    id: "form.element.matrixSelection.columnSelection",
    defaultMessage: "selection unique par Colonne",
    description:
      "Form Element label : Matrix Selection - selection unique par Colonne"
  },
  matrixSelectionLineSelection: {
    id: "form.element.matrixSelection.lineSelection",
    defaultMessage: "selection unique par Ligne",
    description:
      "Form Element label : Matrix Selection - selection unique par Ligne"
  },
  matrixSelectionAllSelection: {
    id: "form.element.matrixSelection.allSelection",
    defaultMessage: "selection Tout",
    description: "Form Element label : Matrix Selection - selection Tout"
  },
  defaultTitleShortText: {
    id: "form.element.defaultTitle.shortText",
    defaultMessage: "Short Text question",
    description: "Default Title shown for the Short Text element of a form"
  },
  defaultTitleAddress: {
    id: "form.element.defaultTitle.address",
    defaultMessage: "Address question",
    description: "Default Title shown for the Address element of a form"
  },
  defaultTitlePhone: {
    id: "form.element.defaultTitle.phone",
    defaultMessage: "Phone question",
    description: "Default Title shown for the Phone element of a form"
  },
  defaultTitleCountry: {
    id: "form.element.defaultTitle.country",
    defaultMessage: "Select a Country",
    description: "Default Title shown for the Country element of a form"
  },
  defaultTitleMail: {
    id: "form.element.defaultTitle.mail",
    defaultMessage: "Mail question",
    description: "Default Title shown for the Mail element of a form"
  },
  defaultTitleDateSelector: {
    id: "form.element.defaultTitle.dateSelector",
    defaultMessage: "Date Selector question",
    description: "Default Title shown for the Date Selector element of a form"
  },
  defaultTitleScrollingList: {
    id: "form.element.defaultTitle.scrollingList",
    defaultMessage: "Scrolling List question",
    description: "Default Title shown for the Scrolling List element of a form"
  },
  defaultTitleMonoSelection: {
    id: "form.element.defaultTitle.monoSelection",
    defaultMessage: "Mono Selection question",
    description: "Default Title shown for the Mono Selection element of a form"
  },
  defaultTitleMultiSelection: {
    id: "form.element.defaultTitle.multiSelection",
    defaultMessage: "Multi Selection question",
    description: "Default Title shown for the Multi Selection element of a form"
  },
  defaultTitleCurrency: {
    id: "form.element.defaultTitle.currency",
    defaultMessage: "Currency question",
    description: "Default Title shown for the Currency element of a form"
  },
  defaultTitleScale: {
    id: "form.element.defaultTitle.scale",
    defaultMessage: "Scale question",
    description: "Default Title shown for the Scale element of a form"
  },
  defaultTitleNumber: {
    id: "form.element.defaultTitle.number",
    defaultMessage: "Number question",
    description: "Default Title shown for the Number element of a form"
  },
  defaultTitlePercent: {
    id: "form.element.defaultTitle.percent",
    defaultMessage: "Percent question",
    description: "Default Title shown for the Percent element of a form"
  },
  defaultTitleFreetext: {
    id: "form.element.defaultTitle.freeText",
    defaultMessage: "Freetext question",
    description: "Default Title shown for the Freetext element of a form"
  },
  defaultTitleMatrixSelection: {
    id: "form.element.defaultTitle.matrixSelection",
    defaultMessage: "Matrix Selection question",
    description:
      "Default Title shown for the Matrix Selection element of a form"
  }
})

/**
 * This is all elements that are addable to a form by an admin
 * Every element respect this model
 *
 * {
 *   text: String,
 *   label: String,
 *   icon: Component,
 *   default: {
 *     title: String,
 *     description: String,
 *     required: Boolean,
 *     data: Object, - should contain every properties of the element,
 *     for example minDate and maxDate for a Date element, every property is an object with a "type", a "value" and maybe a "label"
 *     jumpAttributeIds: Array of Strings - set to [] by default, it will be populated when the element is added by the user, every attribute id will be store
 *   },
 *   jumpAttributesGenerator: Function - (element, form, attributes) =>
 *     element - The currently selected element by the admin
 *     form - The current edited form by the admin
 *     attributes - The current attributes values of the form, should be updated here
 *     This function should return an array containing all the attributes the element needs (they will be created in Mongo)
 * }
 */

export const FORM_ADDABLE_ELEMENTS_TYPES = {
  TEXT: "text", // Texte court
  ADDRESS: "address", // Adresse
  PHONE: "phone", // Téléphone
  COUNTRY: "country", // Pays
  MAIL: "mail", // Email
  DATE: "date", // Sélecteur de date
  LIST: "list", // Liste déroulante
  MONO_SELECTION: "monoSelection", // Sélection unique
  MULTI_SELECTION: "multiSelection", // Sélection multiple
  CURRENCY: "currency_value", // Valeur Monétaire
  SCALE: "scale", // Échelle chiffrée
  NUMBER: "number", // Nombre
  PERCENT: "percent", // Pourcentage
  SEPARATOR: "separator", // Séparateur
  FREETEXT: "freeText", // Explication
  MATRIX_SELECTION: "matrixSelection" // Matrice de sélection
}

export const TEXT_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.TEXT,
  label: messages.shortText,
  icon: TextFormatIcon,
  default: {
    title: messages.defaultTitleShortText,
    description: "Description",
    required: false,
    data: {
      placeholder: {
        type: "text",
        label: messages.placeholder,
        value: null
      },
      defaultText: {
        type: "text",
        label: messages.shortTextDefaultText,
        value: null
      },
      minLength: {
        type: "number",
        label: messages.shortTextMinLength,
        value: 1
      },
      maxLength: {
        type: "number",
        label: messages.shortTextMaxLength,
        value: 50
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_texte_court_${element.id}`,
      type: "text",
      label: `${form.name} - Texte court - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const ADDRESS_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.ADDRESS,
  label: messages.address,
  icon: RoomIcon,
  default: {
    title: messages.defaultTitleAddress,
    description: "Description",
    required: false,
    data: {
      cityRequired: {
        type: "bool",
        label: messages.addressCityRequired,
        value: false
      },
      postalCodeRequired: {
        type: "bool",
        label: messages.addressPostalCodeRequired,
        value: false
      },
      countryRequired: {
        type: "bool",
        label: messages.addressCountryRequired,
        value: false
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_adresse_${element.id}`,
      type: "text",
      label: `${form.name} - Adresse - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const PHONE_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.PHONE,
  label: messages.phone,
  icon: PhoneIcon,
  default: {
    title: messages.defaultTitlePhone,
    description: "Description",
    required: false,
    data: {},
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_telephone_${element.id}`,
      type: "text",
      label: `${form.name} - Téléphone - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const COUNTRY_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.COUNTRY,
  label: messages.country,
  icon: LanguageIcon,
  default: {
    title: messages.defaultTitleCountry,
    description: "Description",
    required: false,
    data: {},
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_pays_${element.id}`,
      type: "country",
      label: `${form.name} - Pays - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const MAIL_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.MAIL,
  label: messages.mail,
  icon: MailIcon,
  default: {
    title: messages.defaultTitleMail,
    description: "Description",
    required: false,
    data: {},
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_email_${element.id}`,
      type: "text",
      label: `${form.name} - Email - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const DATE_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.DATE,
  label: messages.dateSelector,
  icon: CalendarTodayIcon,
  default: {
    title: messages.defaultTitleDateSelector,
    description: "Description",
    required: false,
    data: {
      minDate: {
        type: "text",
        label: messages.dateSelectorMinDate,
        value: "01/01/1900"
      },
      maxDate: {
        type: "text",
        label: messages.dateSelectorMaxDate,
        value: "01/01/2100"
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_date_${element.id}`,
      type: "date",
      label: `${form.name} - Date - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const LIST_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.LIST,
  label: messages.scrollingList,
  icon: ArrowDropDownIcon,
  default: {
    title: messages.defaultTitleScrollingList,
    description: "Description",
    required: false,
    data: {
      list: {
        type: "list",
        label: messages.scrollingListTagsList,
        value: {}
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_liste_deroulante_${element.id}`,
      type: "text",
      label: `${form.name} - Liste déroulante - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const MONO_SELECTION_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.MONO_SELECTION,
  label: messages.monoSelection,
  icon: DoneIcon,
  default: {
    title: messages.defaultTitleMonoSelection,
    description: "Description",
    required: false,
    data: {
      list: {
        type: "list",
        value: ["Option 1"]
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_selection_unique_${element.id}`,
      type: "text",
      label: `${form.name} - Sélection unique - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const MULTI_SELECTION_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.MULTI_SELECTION,
  label: messages.multiSelection,
  icon: DoneAllIcon,
  default: {
    title: messages.defaultTitleMultiSelection,
    description: "Description",
    required: false,
    data: {
      list: {
        type: "list",
        value: ["Option 1"]
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_selection_multiple_${element.id}`,
      type: "text",
      label: `${form.name} - Sélection multiple - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const CURRENCY_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.CURRENCY,
  label: messages.currency,
  icon: AttachMoneyIcon,
  default: {
    title: messages.defaultTitleCurrency,
    description: "Description",
    required: false,
    data: {
      currency: {
        type: "currency",
        label: words.currency,
        value: "USD"
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_valeur_monetaire_${element.id}`,
      type: "currency_value",
      label: `${form.name} - Valeur monétaire - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const SCALE_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.SCALE,
  label: messages.scale,
  icon: TuneIcon,
  default: {
    title: messages.defaultTitleScale,
    description: "Description",
    required: false,
    data: {
      startAtOne: {
        type: "bool",
        label: messages.scaleStartsAtOne,
        value: false
      },
      maxScale: {
        type: "number",
        label: messages.scaleMaxScale,
        value: 10
      },
      showLabels: {
        type: "bool",
        label: messages.scaleShowLabels,
        value: false
      },
      leftText: {
        type: "text",
        label: messages.scaleLeftText,
        value: ""
      },
      middleText: {
        type: "text",
        label: messages.scaleMiddleText,
        value: ""
      },
      rightText: {
        type: "text",
        label: messages.scaleRightText,
        value: ""
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_echelle_chiffree_${element.id}`,
      type: "text",
      label: `${form.name} - Échelle chiffrée - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const NUMBER_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.NUMBER,
  label: messages.number,
  icon: Filter9PlusIcon,
  default: {
    title: messages.defaultTitleNumber,
    description: "Description",
    required: false,
    data: {
      positiveOnly: {
        type: "bool",
        label: messages.numberPositiveOnly,
        value: false
      },
      minValue: {
        type: "number",
        label: messages.numberMinValue,
        value: -25
      },
      maxValue: {
        type: "number",
        label: messages.numberMaxValue,
        value: 25
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_nombre_${element.id}`,
      type: "integer",
      label: `${form.name} - Nombre - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const PERCENT_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.PERCENT,
  label: messages.percent,
  icon: Filter9PlusIcon,
  default: {
    title: messages.defaultTitlePercent,
    description: "Description",
    required: false,
    data: {},
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_pourcentage_${element.id}`,
      type: "percent",
      label: `${form.name} - Pourcentage - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}
export const SEPARATOR_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.SEPARATOR,
  label: messages.separator,
  icon: RemoveIcon,
  default: {
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: () => []
}
export const FREETEXT_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.FREETEXT,
  label: messages.freeText,
  icon: ChatIcon,
  default: {
    title: messages.defaultTitleFreetext,
    data: {
      freeText: ""
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: () => []
}
export const MATRIX_SELECTION_ELEMENT = {
  type: FORM_ADDABLE_ELEMENTS_TYPES.MATRIX_SELECTION,
  label: messages.matrixSelection,
  icon: SelectAllIcon,
  default: {
    title: messages.defaultTitleMatrixSelection,
    description: "Description",
    required: false,
    data: {
      selection: {
        type: "select",
        label: messages.matrixSelectionTypeSelection,
        list: [
          {
            name: "column",
            type: "bool",
            value: false,
            label: messages.matrixSelectionColumnSelection
          },
          {
            name: "line",
            type: "bool",
            value: false,
            label: messages.matrixSelectionLineSelection
          },
          {
            name: "unique",
            type: "bool",
            value: false,
            label: messages.matrixSelectionMonoSelection
          },
          {
            name: "all",
            type: "bool",
            value: true,
            label: messages.matrixSelectionAllSelection
          }
        ]
      },
      initialValue: {
        rowLabels: ["Option 1"],
        columnLabels: ["Option 1"],
        values: {
          "Option 1": {
            "Option 1": false
          }
        }
      }
    },
    jumpAttributeIds: []
  },
  jumpAttributesGenerator: (element, form) => {
    const newAttribute = {
      jumpIdentifier: `F${form.formIdentifier}_matrice_de_selection_${element.id}`,
      type: "text",
      label: `${form.name} - Matrice de sélection - ${element.id}`,
      historical: false
    }
    return [newAttribute]
  }
}

let ELEMENTS = [
  TEXT_ELEMENT,
  ADDRESS_ELEMENT,
  PHONE_ELEMENT,
  COUNTRY_ELEMENT,
  SEPARATOR_ELEMENT,
  MAIL_ELEMENT,
  DATE_ELEMENT,
  LIST_ELEMENT,
  MONO_SELECTION_ELEMENT,
  MULTI_SELECTION_ELEMENT,
  CURRENCY_ELEMENT,
  SCALE_ELEMENT,
  NUMBER_ELEMENT,
  PERCENT_ELEMENT,
  FREETEXT_ELEMENT,
  MATRIX_SELECTION_ELEMENT
]

// Disallow reassignment from external modules
export const FORM_ADDABLE_ELEMENTS = ELEMENTS

export const COUNTING_IGNORED_ELEMENT_TYPES = [
  SEPARATOR_ELEMENT.type,
  FREETEXT_ELEMENT.type
]

// This function only changes the different messages from an object to a string (translation by react-intl)
export const setupAddableElements = (intl) => {
  const { formatMessage: format } = intl
  ELEMENTS = ELEMENTS.map((element) => {
    const formattedElement = { ...element }
    if (typeof element.label !== "string") {
      formattedElement.label = format(element.label)
    }

    if (element.default.title && typeof element.default.title !== "string") {
      formattedElement.default.title = format(element.default.title)
    }

    if (element.default.data) {
      Object.keys(element.default.data).forEach((key) => {
        if (
          element.default.data[key].label &&
          typeof element.default.data[key].label !== "string"
        ) {
          formattedElement.default.data[key].label = format(
            element.default.data[key].label
          )
        }
      })
    }

    return formattedElement
  })
}
